var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWtsp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.89,
    height: 24,
    viewBox: "0 0 23.89 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 11.94,
    y1: 22.81,
    x2: 12.04,
    y2: 5.91,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 26)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#57d163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23b33a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.41,3.49A11.89,11.89,0,0,0,.1,11.89a11.94,11.94,0,0,0,1.59,5.95L0,24l6.31-1.65A11.92,11.92,0,0,0,12,23.79h0a11.89,11.89,0,0,0,8.41-20.3ZM12,21.78h0a9.85,9.85,0,0,1-5-1.37l-.36-.22-3.75,1,1-3.64-.23-.38a9.78,9.78,0,0,1-1.51-5.26A9.89,9.89,0,0,1,12,2a9.62,9.62,0,0,1,3.78.75A9.79,9.79,0,0,1,19,4.91a9.85,9.85,0,0,1,2.89,7A9.9,9.9,0,0,1,12,21.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.13,8.11A9.62,9.62,0,0,0,19,4.91a9.79,9.79,0,0,0-3.21-2.15A9.62,9.62,0,0,0,12,2a9.89,9.89,0,0,0-9.89,9.88,9.78,9.78,0,0,0,1.51,5.26l.23.38-1,3.64,3.75-1,.36.22a9.85,9.85,0,0,0,5,1.37h0a9.9,9.9,0,0,0,9.89-9.88A9.67,9.67,0,0,0,21.13,8.11Zm-3.32,8a3,3,0,0,1-2,1.41c-.55.05-1.06.25-3.57-.74a12.21,12.21,0,0,1-5.08-4.49A5.77,5.77,0,0,1,6,9.26,3.33,3.33,0,0,1,7,6.78a1.07,1.07,0,0,1,.79-.37h.57c.21,0,.45,0,.67.52s.84,2.05.92,2.2a.56.56,0,0,1,0,.52,2,2,0,0,1-.3.5c-.14.17-.31.39-.44.52s-.31.31-.13.61a9.12,9.12,0,0,0,1.65,2.06,8.17,8.17,0,0,0,2.39,1.47c.3.15.47.12.65-.07s.74-.87.94-1.17.39-.25.67-.15,1.73.82,2,1,.49.22.57.35A2.53,2.53,0,0,1,17.81,16.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.13,8.11A9.62,9.62,0,0,0,19,4.91a9.79,9.79,0,0,0-3.21-2.15A9.62,9.62,0,0,0,12,2a9.89,9.89,0,0,0-9.89,9.88,9.78,9.78,0,0,0,1.51,5.26l.23.38-1,3.64,3.75-1,.36.22a9.85,9.85,0,0,0,5,1.37h0a9.9,9.9,0,0,0,9.89-9.88A9.67,9.67,0,0,0,21.13,8.11Zm-3.32,8a3,3,0,0,1-2,1.41c-.55.05-1.06.25-3.57-.74a12.21,12.21,0,0,1-5.08-4.49A5.77,5.77,0,0,1,6,9.26,3.33,3.33,0,0,1,7,6.78a1.07,1.07,0,0,1,.79-.37h.57c.21,0,.45,0,.67.52s.84,2.05.92,2.2a.56.56,0,0,1,0,.52,2,2,0,0,1-.3.5c-.14.17-.31.39-.44.52s-.31.31-.13.61a9.12,9.12,0,0,0,1.65,2.06,8.17,8.17,0,0,0,2.39,1.47c.3.15.47.12.65-.07s.74-.87.94-1.17.39-.25.67-.15,1.73.82,2,1,.49.22.57.35A2.53,2.53,0,0,1,17.81,16.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.42,14.39c-.3-.15-1.76-.87-2-1s-.47-.15-.67.15-.77,1-.94,1.17-.35.22-.65.07a8.17,8.17,0,0,1-2.39-1.47,9.12,9.12,0,0,1-1.65-2.06c-.18-.3,0-.46.13-.61s.3-.35.44-.52a2,2,0,0,0,.3-.5.56.56,0,0,0,0-.52C9.86,9,9.29,7.51,9,6.93s-.46-.51-.67-.52H7.78A1.07,1.07,0,0,0,7,6.78,3.33,3.33,0,0,0,6,9.26a5.77,5.77,0,0,0,1.21,3.07,12.21,12.21,0,0,0,5.08,4.49c2.51,1,3,.79,3.57.74a3,3,0,0,0,2-1.41A2.53,2.53,0,0,0,18,14.74C17.91,14.61,17.71,14.54,17.42,14.39Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWtsp);
export default __webpack_public_path__ + "static/media/wtsp.cbd8673bd642ce5808c4549fd979df2e.svg";
export { ForwardRef as ReactComponent };